// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D3_Ru3N0Ok53DGboPppXHKb{position:relative}.D3_Ru3N0Ok53DGboPppXHKb svg{position:absolute;inset:0 0 0 0;width:100%;height:100%}`, "",{"version":3,"sources":["webpack://./src/components/D3/D3.module.scss"],"names":[],"mappings":"AAAA,yBACE,iBAAA,CACA,6BACE,iBAAA,CACA,aAAA,CACA,UAAA,CACA,WAAA","sourcesContent":[".D3 {\n  position: relative;\n  svg {\n    position: absolute;\n    inset: 0 0 0 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"D3": `D3_Ru3N0Ok53DGboPppXHKb`
};
export default ___CSS_LOADER_EXPORT___;
